import validatePresence from './validatePresence';

const validateName = (value: unknown): string | boolean => validatePresence(value, ['firstName', 'lastName']);

export default validateName;